import { ReactNode } from 'react';
import { Stack, Typography } from '@rossum/ui/material';
import { EMPTY_PLACEHOLDER } from '../../../core/utils';

type RenderHeaderProps = {
  label?: string;
  icon?: ReactNode;
};

export const RenderHeader = ({ label, icon }: RenderHeaderProps) => {
  return (
    <Stack direction="row" spacing={1} useFlexGap>
      {icon}
      <Typography variant="body2" color="textSecondary">
        {label ?? EMPTY_PLACEHOLDER}
      </Typography>
    </Stack>
  );
};
